export default {
  namespaced: true,
  action_plan: {
    validatedBy: 'Validado por',
    tasks: 'Tareas',
    userValidated: 'Usuario que valido',
    validatedDate: 'Fecha validación',
    validated: 'Validado',
    validate: 'Validar',
    assignUsers: 'Asignar usuarios',
    deadline: 'Fecha límite',
    deadlineOverdue: 'La tarea está atrasada con {days} día(s)',
    deadlineToday: 'La tarea vence hoy',
    deadlineRemaining: 'Faltan {days} día(s) para completar la tarea',
    title: 'Plan de acción | Planes de acción',
    label: 'Plan de acción | Planes de acción',
    messages: {
      flowchart_not_ready: 'El editor del flujo aún se está cargando. Inténtalo de nuevo en unos segundos.',
      alarm_type_required: 'Selecciona al menos un tipo de alarma.'
    },
    answeredDate: 'Fecha respondida',
    openedDate: 'Fecha de apertura',
    start_modal: {
      title: 'Se iniciará el plan de acción "{name}"'
    },
    replace_modal: {
      title: 'El plan de acción activo pasará a ser "{name}"',
      description: 'Los planes de acción anteriores quedarán deshabilitados y serán visibles en el historial.',
    },
    fields: {
      name: {
        label: 'Nombre del plan de acción',
        placeholder: 'Nombre del plan de acción'
      },
      default: {
        label: "Plan de acción por default"
      },
      all_alarm_types: {
        label: "Todos los tipo de alarma"
      },
      action_plan_status: {
        label: 'Estado',
        options: {
          attending: 'Atendiendo',
          waiting: 'Esperando',
        }
      },
    },
    nodes: {
      decision: {
        name: 'Decisión',
        config: {
          question: 'Pregunta',
          yes: 'Sí',
          no: 'No',
          new_output: 'Respuesta',
          add_output: 'Agregar respuesta',
          remove_output: 'Eliminar respuesta',
        }
      },
      terminate: {
        name: 'Finalizar'
      }
    },
    viewer: {
      preview: "vista previa",
      answer: 'Respuesta',
      comments: "Comentarios",
      execute_command: 'Ejecutar comando',
      execute: 'Ejecutar',
      completed: 'Listo',
      error: 'Error',
      continue: 'Continuar',
      finalized: 'Finalizado',
      start_form: 'Iniciar formulario',
      response_form_id_missing:
        'La respuesta del servidor no incluyó el id del formulario. Revisa la API o contacta a soporte.',
      drag_form_hint: 'Arrastra a un slot del grid para abrir el formulario aquí',
      advance: 'Avanzar',
      form_not_answered: 'El formulario no ha sido respondido',
      form_answered_success: 'Formulario verificado correctamente',
      executed_success: 'Comando ejecutado correctamente',
      executed_error: 'Ocurrió un error al ejecutar el comando',
      notify: 'Notificar',
      panel_failure_title: 'Falla del panel',
      panel_failure_yes: 'Sí',
      panel_failure_no: 'No',
      panel_failure_answered_no: 'Sin falla de panel',
      panel_failure_comment: 'Comentario de la notificación',
      panel_failure_comment_hint:
        'Este comentario se enviará en la notificación a los usuarios con permiso de alarmas del plan de acción.',
      panel_failure_notified: 'Notificación de falla de panel enviada',
    },
    list: {
      title: 'Log de planes de acción',
      filters: {
        tenants: 'Tenants',
        start_date: "Fecha de inicio",
        end_date: "Fecha de fin",
      },
      cols: {
        col1: 'Nombre',
        col2: 'Usuario',
        col3: 'Tenant',
        col4: 'Alarma',
        col5: 'Fecha',
      }
    },
    documentTable: {
      name: 'Nombre del Documento',
      description: 'Descripción',
      tenant: 'Tenant',
      view: 'Visualizar',
      created_at: 'Creado en',
      updated_at: 'Actualizado en'
    },
    documentActionPlan: {
      title: 'Documentos del Plan de Acción',
      addDocument: 'Agregar documento',
      document: 'Documento',
      view: 'Visualizar',
    }
  },
}
